module.exports = __webpack_public_path__ + "img/email-contact.c8ff5893.svg";